import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../../../common/Fieldset";
import Row from "../../../common/Row";
import Col from "../../../common/Col";
import RadioButtonGroup from "../../../common/RadioButtonGroup";


const Verzekering = (props) => {
    const {
        disabled,
        model,
        validationMessageType,
        getError,
        onChange,
        hasStep4Status,
        hasFinalStatus
    } = props;
    return <Fieldset title="Verzekering">
   
        <Row>
            <Col size={12}>
                 <p><b>
                    {"Ik ben op de hoogte dat ik als organisator van een evenement verzekerd moet zijn. Voor meer info raadpleeg het verenigingsloket."}
                </b></p>
                <a className="external-link" href="https://www.verenigingsloket.be/nl/advies/evenement_organiseren" target="_blank">
                    {"https://www.verenigingsloket.be/nl/advies/evenement_organiseren "}
                    <i className="fa fa-external-link"></i>
                </a>
            </Col>
        </Row>
        <RadioButtonGroup
            size={12}
            name={"geinformeerdIVMVerzekering"}
            key={"geinformeerdIVMVerzekering"}
            items={[{ value: true, label: "Ja" }]}
            value={model.geinformeerdIVMVerzekering}
            onChange={onChange}
            horizontal
            disabled={disabled || hasStep4Status || hasFinalStatus}
            validationMessage={getError('geinformeerdIVMVerzekering')}
            validationMessageType={validationMessageType}
        />
        <Row>
            <Col size={12}>
                <p><b>{"Socio-culturele verenigingen kunnen een gratis sportverzekering aanvragen bij Sport Vlaanderen."}</b></p>
                <a className="external-link"href="https://www.sport.vlaanderen/wij-helpen-bij-de-organisatie-van-jouw-sportactiviteit/gratis-sportverzekering/" target="_blank">
                    {"https://www.sport.vlaanderen/wij-helpen-bij-de-organisatie-van-jouw-sportactiviteit/gratis-sportverzekering/ "}
                    <i className="fa fa-external-link"></i>
                </a>
            </Col>
        </Row>
    </Fieldset>;
};

Verzekering.propTypes = {
    disabled: PropTypes.bool,
    model: PropTypes.object.isRequired,
    validationMessageType: PropTypes.string,
    getError: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    hasStep4Status: PropTypes.bool.isRequired,
    hasFinalStatus: PropTypes.bool
};

export default Verzekering;
